import "$styles/index.sass"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
import "./photoswipe.js"

console.info("Bridgetown is loaded!")
